class EventEmitter {
  events = {}

  on(event, listener) {
    if (typeof this.events[event] !== 'object') {
      this.events[event] = []
    }

    this.events[event].push(listener)
  }

  removeListener(event, listener) {
    if (typeof this.events[event] === 'object') {
      const listenerIndex = this.events[event].indexOf(listener)

      if (listenerIndex > -1) this.events[event].splice(listenerIndex, 1)
    }
  }

  emit(event, ...args) {
    if (typeof this.events[event] === 'object') {
      const listeners = this.events[event]

      for (const listener of listeners) {
        listener.apply(this, args)
      }
    }
  }

  once(event, listener) {
    this.on(event, function listenOnce(...args) {
      this.removeListener(event, listenOnce)
      listener.apply(this, args)
    })
  }
}

export default EventEmitter
